import "react-day-picker/lib/style.css";
import {
  RenderWarning,
  RenderActions,
  RenderText,
  RenderStateSelect,
  RenderCountySelect,
} from "../Shared/renderCells";

export default [
  {
    Header: " ", // needs to be a space if you want it blank
    width: 5,
    minWidth: 5,
    Cell: RenderWarning,
  },
  {
    Header: "1. State*",
    accessor: "appBState",
    width: 22,
    minWidth: 22,
    Cell: (props) =>
      RenderStateSelect({
        rowBlsAreaProperty: "appBMsaName",
        appxCountyProperty: "appBCounty",
        ...props,
      }),
  },
  {
    Header: "2. County*",
    accessor: "appBCounty",
    width: 22,
    minWidth: 22,
    Cell: (props) =>
      RenderCountySelect({
        rowBlsAreaProperty: "appBMsaName",
        appxStateProperty: "appBState",
        ...props,
      }),
  },
  {
    Header: "3. MSA / OES Area Code*",
    accessor: "appBMsaCode",
    width: 10,
    minWidth: 10,
    Cell: RenderText,
  },
  {
    Header: "3a. MSA Name / OES Area Title*",
    accessor: "appBMsaName",
    width: 60,
    minWidth: 55,
    Cell: RenderText,
  },
  {
    Header: "Actions",
    accessor: "actions",
    width: 10,
    minWidth: 10,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: RenderActions,
  },
];
